import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\ItemDossier\FetchItemComponentsController::__invoke
* @see app/Http/Controllers/Dossier/ItemDossier/FetchItemComponentsController.php
* @route '/api/dossier/{dossier}/fetch-item-components/{item}'
*/
const FetchItemComponentsController = (args: { dossier: string | number | { id: string | number }, item: string | { id: string } } | [dossier: string | number | { id: string | number }, item: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchItemComponentsController.url(args, options),
    method: 'get',
})

FetchItemComponentsController.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/fetch-item-components/{item}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\ItemDossier\FetchItemComponentsController::__invoke
* @see app/Http/Controllers/Dossier/ItemDossier/FetchItemComponentsController.php
* @route '/api/dossier/{dossier}/fetch-item-components/{item}'
*/
FetchItemComponentsController.url = (args: { dossier: string | number | { id: string | number }, item: string | { id: string } } | [dossier: string | number | { id: string | number }, item: string | { id: string } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
            item: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
        item: typeof args.item === 'object'
        ? args.item.id
        : args.item,
    }

    return FetchItemComponentsController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace('{item}', parsedArgs.item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\ItemDossier\FetchItemComponentsController::__invoke
* @see app/Http/Controllers/Dossier/ItemDossier/FetchItemComponentsController.php
* @route '/api/dossier/{dossier}/fetch-item-components/{item}'
*/
FetchItemComponentsController.get = (args: { dossier: string | number | { id: string | number }, item: string | { id: string } } | [dossier: string | number | { id: string | number }, item: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchItemComponentsController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\ItemDossier\FetchItemComponentsController::__invoke
* @see app/Http/Controllers/Dossier/ItemDossier/FetchItemComponentsController.php
* @route '/api/dossier/{dossier}/fetch-item-components/{item}'
*/
FetchItemComponentsController.head = (args: { dossier: string | number | { id: string | number }, item: string | { id: string } } | [dossier: string | number | { id: string | number }, item: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FetchItemComponentsController.url(args, options),
    method: 'head',
})

export default FetchItemComponentsController